import { DependencyList, useCallback, useEffect } from 'react'

const useMessageData = (fn: (data: MessageEvent['data']) => void, deps: DependencyList = []) => {
    const callback = useCallback((event: MessageEvent) => fn(event.data), deps)

    useEffect(() => {
        window.uiBus.addEventListener('message', callback)

        return () => window.uiBus.removeEventListener('message', callback)
    }, [callback])
}

export default useMessageData
